goog.provide('el8.uiwidget.listeditor');

goog.require('el8.model.base');
goog.require('el8.service.infoField');
goog.require('el8.template.uiwidget.listeditor');
goog.require('el8.uiwidget.LegacyMindreader');
goog.require('el8.uiwidget.NewMindreader');
goog.require('el8.util.dom');
goog.require('el8.util.event');
goog.require('el8.util.string');


/**
 * This is an auto-expanding/collapsing list of text inputs for managing
 * a list of related items. E.g., a list of tests on an order
 * or the list of social history items for the patient. We use it
 * extensively, often in combination with the NewMindreader
 * (so each entry in the list can be filled in from autocomplete).
 *
 * A listeditor will usually be added to a Form via listeditorOpts,
 * rather than directly instantiated. See listeditorOpts.js for
 * the specifications for a lot of common listeditors and
 * staffGroups.js / history.js for a couple instantiations of a listeditor.
 *
 * One place you may run into trouble: the user event handling code
 * here can be fairly fragile, especially when combined with other widgets
 * (mindreader, multilist) that have their own click/blur/keydown listeners.
 * Adding a new kind of use for one of these widgets or layering a new
 * widget on top of / under this one can reveal issues there.
 */
el8.uiwidget.listeditor = function(opts) {
    this._opts = opts || {};
};

// *********************
//  Initialization
// *********************
el8.uiwidget.listeditor.prototype.init = function(infoField) {

    // Preferably, we pass in an already formed infoField; else, we create
    this.infoField = infoField || null;

    /**
     * Set all the options
     */
    this.$listContainer = jQuery.isFunction(this._opts.list) ? this._opts.list() : this._opts.list;

    this.labelClass = this._opts.labelClass || (this._opts.labelType ?
        ((this._opts.labelType === 'none') ? '' :
         ((this._opts.labelType === 'short') ? 'el8FieldShortLabelPadding' :
          ((this._opts.labelType === 'medium') ? 'el8FieldMediumLabelPadding' :
           ((this._opts.labelType === 'long') ? 'el8FieldLongLabelPadding' : 'el8FieldShortLabelPadding')))) :
            'el8FieldShortLabelPadding');

    this.readOnly = (this._opts.readOnly === true); // defaults to false
    this.editFriendly = (this._opts.editFriendly === true); // defaults to false
    this.noRemove = (this._opts.noRemove === true); // defaults to false
    this.sortable = (this._opts.sortable === true); // defaults to false
    this.sortableConnectWith = this._opts.sortableConnectWith || false;
    this.sortableRemoveFn = this._opts.sortableRemoveFn || null;
    this.sortableActivateFn = this._opts.sortableActivateFn || null;
    this.sortableDeactivateFn = this._opts.sortableDeactivateFn || null;
    this.dropdownFn = this._opts.dropdownFn || null;
    this.triggerMap = this._opts.triggerMap || null;
    this.autoHideInput = (this._opts.autoHideInput === true); // defaults to false
    // if this is defined, when an id-less (string) entry is selected,
    // instead of being added to the LE, it will be passed to this function
    this._handleStringEntryFn = this._opts.handleStringEntryFn || null;

    // Heights and widths expected to be numerical values
    this.iconWidth = 12;
    this.entryHeight = this._opts.entryHeight || 16;
    this.entryWidth = this._opts.entryWidth || null;

    this.infoText = this._opts.infoText || '...';
    this.maxLength = this._opts.maxLength || (this.infoField && this.infoField.getMaxLength()) || null;
    this.idPrefix = this._opts.idPrefix || null;

    // saveFn must return saved item; takes as arguments "text", "id", "index"
    // and then successCb, errorCb
    this.saveFn = this._opts.saveFn || null;
    this.removeFn = this._opts.removeFn || function() {};

    this.addEntryFn = this._opts.addEntryFn || function() {};
    this.convertTextToItemFn = this._opts.convertTextToItemFn || null;

    // sortSaveFn takes an array of id's as an argument
    this.sortSaveFn = this._opts.sortSaveFn || function() {};

    this.getItemTextFn = this._opts.getItemTextFn || function(obj) { return obj || ''; };
    this.getItemDisplayOnlyTextFn = this._opts.getItemDisplayOnlyTextFn || null;
    this.getItemIdFn = this._opts.getItemIdFn || null;
    this.getItemTriggerFn = this._opts.getItemTriggerFn || function() { return ''; };
    this.shouldItemHighlightFn = this._opts.shouldItemHighlightFn || function() { return false; };

    // Handler add-ons
    this.onEditStart = this._opts.onEditStart || null;

    //if this is a mindreader and we are assigning IDs to the LEs:
    //then make sure we set things up for de-duplication
    var that = this;
    if (this._opts.mindreaderOpts && this.convertTextToItemFn) {
        // don't blur/change on selection, because it causes issues when editing existing entries
        this._opts.mindreaderOpts['formatSelected'] = function(item) { return null; };
        var oldSelectFn = this._opts.mindreaderOpts['selectFn'];
        this._opts.mindreaderOpts['selectFn'] = function(event, item) {
            var returnVal = null;
            if (oldSelectFn) { returnVal = oldSelectFn(event, item); }
            item = returnVal || item; //let the default selectFn return a modified item if it wishes
            var alreadyExists = Boolean(that.idToEntryMap[that.getItemIdFn(item)]);
            that.addEntry(item, alreadyExists); //highlight if the item already exists
            return returnVal;
        };
    }
    //if this is a mindreader and display-only text exists, this cannot also be a sticky-list
    if (this._opts.mindreaderOpts && this.getItemDisplayOnlyTextFn && this._opts.mindreaderOpts['stickyListInput']) {
        this._opts.mindreaderOpts['stickyListInput'] = false;
    }

    // Optional to have external "previous" or "next" elements for navigation
    this.focusExternalNext = null;
    if (this._opts.nextElt) { this.setNextElt(this._opts.nextElt); }

    this.focusExternalPrev = null;
    if (this._opts.prevElt) { this.setPrevElt(this._opts.prevElt); }

    /**
     * Rest of initialization
     */
    // State variables
    this.idToEntryMap = {};
    this.idToItemMap = {};
    this._lastSavedEntries = []; // For dirty checking

    this.activeIndex = -1;
    this.$activeEntry = null;

    this.mousedownMindreader = false;

    // Add custom class to the $listContainer
    this.$listContainer.addClass('le-list');

    if (!this.readOnly) {
        this._addInputSection();
        this._bindControls();
    } else {
        // Add additional formatting that normally happens in addInputSection
        this.$listContainer.wrap($('<div class="le-container '+this.labelClass+'">')); // XSS OK -KF
        if (this.entryWidth) {
            this.$listContainer.parent('.le-container').outerWidth(this.entryWidth);
        }
    }

    return this;
};

el8.uiwidget.listeditor.prototype._addInputSection = function() {

    // XSS OK -KF

    // Create input area
    var inputArea = $('<div class="le-inputarea el8EditorTextareaWrap">');
    var inputWrap = $('<div class="le-content el8FieldSection">');
    if (this.infoField) {
        // Grab input field if we already have it through infoField
        this.$input = this.infoField.getInputField()
                            .addClass('le-input');
    } else {
        // Else, create new input field and create infoField as well
        this.$input = $('<textarea class="le-input">');
        this.infoField = el8.service.infoField.addInfoField({
            field: this.$input,
            infoText: this.infoText,
            maxLength: this.maxLength
        });
    }
    $(this.$listContainer, this.$input).wrap($('<div class="le-container '+this.labelClass+'">'));
    if (this.entryWidth) {
        this.$listContainer.parent('.le-container').outerWidth(this.entryWidth);
    }

    // Append to DOM just the way we'd like, with right classes, etc.
    this.$input.wrap(inputWrap);
    inputArea.append($('<div class="le-icon el8BulletIcon">')).append(this.$input.parent());
    this.$listContainer.after(inputArea);
    $('.le-icon', inputArea).outerWidth(this.iconWidth).height(this.entryHeight);
    $('.le-input', inputArea).height(this.entryHeight).css('width', '100%');
    $('.le-content', inputArea).css('margin-left', this.iconWidth);

    this.$inputArea = inputArea;
};

el8.uiwidget.listeditor.prototype._bindControls = function() {

    var that = this;

    this._isMouseBinded = false;
    this._clickHandler = function(e) {
        // Explicitly listens for clicks on mindreader
        var $target = $(e.target);
        if (that.mindreader && that.mindreader.isShown) {
            if ($target.closest('.mr-dropdown-item').length) {
                that._selectFromMindreader(e);
            // Many things were broken. The intention here now is if they click outside
            // the input, we want to trigger any side effects that the given input is
            // supposed to do (e.g. save the visit note bullet), but if they click
            // inside the input, we should keep the mindreader open. They may, for
            // example, be clicking into the middle of a word and want to continue typing.
            } else if (!($target.is(that.$input) || $.contains(that.$input, $target))) {
                that._selectActiveInputOrEntry();
            }
        }
        // Always clear the mousedownMindreader
        that.mousedownMindreader = false;
    };
    this._mrMousedownHandler = function() { //attach this to .mr-dropdown
        that.mousedownMindreader = true;
    };


    /* These are listeners on the 'le-input' at the bottom of the listeditor.
     * These keydowns are triggered BEFORE the mindreader's own listeners.
     * (Note this is different from the le-edit listeners below) */
    //TODO: these should be 'delegates' like below, not binds
    this.$input.on('keydown', function(e) {
        switch(e.keyCode) {
            case KEYS.ENTER:
                if (e.shiftKey) { return; }
                // Hitting 'enter' selects current field
                e.preventDefault();
                // If mindreader isn't showing (or doesn't exist), then
                // go ahead with standard behavior
                if (!that.mindreader ||
                    (that.mindreader && !that.mindreader.isShown)) {
                    that._selectInput();
                    that._activateInput();
                // Otherwise, have to select input from mindreader
                } else {
                    that._selectFromMindreader(e, $(this));
                    return false; // Don't bubble to mindreader's handlers
                }
                break;
            case KEYS.TAB:
                that.activeIndex = that.numEntries();
                if (e.shiftKey) {
                    that.activatePrev();
                } else {
                    that._selectInput();
                }
                break;
            case KEYS.ESC:
                e.preventDefault();
                if (that.mindreader && that.mindreader.isShown) {
                    that.mindreader.hide();
                } else {
                    $(this).blur();
                }
                return false;
            default:
                break;
        }
    }).on('focus', function() {
        that._bindMouseHandlers();
    }).on('blur', function() {
        if (that.mousedownMindreader) { return; }
        that._unbindMouseHandlers();
        that._selectActiveInputOrEntry();
        if (that.autoHideInput) { that._updateShowHideInputSection(); }
    });

    // Set up mindreader. Need to be AFTER 'keydown' event gets bound, so
    // that mindreader 'keydown' events come afterwards
    this.mindreader = null;
    if (this._opts.mindreaderOpts) {
        this._opts.mindreaderOpts['ignoreStr'] = this.infoField.getInfoText();
        this._opts.mindreaderOpts['listeditor'] = true;
        if (this._opts.mindreaderOpts['newMindreader']) {
            this.mindreader =
                (new el8.uiwidget.NewMindreader(this._opts.mindreaderOpts).init(this.$input));
        } else {
            this.mindreader =
                (new el8.uiwidget.LegacyMindreader(this._opts.mindreaderOpts).init(this.$input));
        }
    }

    /* These are listeners on the 'le-edit' from previous entries in the listeditor.
     * These keydowns are triggered AFTER the mindreader's own listeners.
     * (Note this is different from the le-input listeners above) */
    var $container = $(this.$listContainer[0]);
    $container.on('keydown', '.le-edit', function(e) {
        switch (e.keyCode) {
            case KEYS.ENTER:
                // Hitting 'enter' creates new lines
                if (!e.shiftKey) {
                    if (!that.mindreader ||
                       (that.mindreader && !that.mindreader.isShown)) {
                        e.preventDefault();
                        that._activateInput();
                    } else {
                        that._selectFromMindreader(e, $(this));
                        return false;
                    }
                }
                break;
            case KEYS.ESC:
                e.preventDefault();
                $(this).blur();
                break;
            case KEYS.TAB:
                e.preventDefault();
                if (e.shiftKey) { that.activatePrev(); }
                else { that.activateNext(); }
                break;
            default:
                break;
        }
    }).on('keyup', '.le-edit', function(e) {
        that._growTextarea($(this), $(this).parents('.le-entry:first'));
    }).on('focus', '.le-edit', function(e) {
        that._bindMouseHandlers();
        var $entry = $(this).closest('.le-entry');
        if (that._getEntryId($entry) !== that.activeIndex) {
            that.editEntry($entry, true);
        }
    }).on('blur', '.le-edit', function(e) {
        if (that.mousedownMindreader) { return; }
        that._unbindMouseHandlers();
        var $entry = $(this).closest('.le-entry');

        if (that.convertTextToItemFn) {
            var val = $(this).val();
            var item = that.convertTextToItemFn(val);
            if (item && typeof item !== 'string') {
                var itemId = that.getItemIdFn(item);
                //if we changed the item typed in, make sure the ID and display text reflect the change
                if (String(itemId) !== that._getEntryId($entry)) {
                    var alreadyExists = Boolean(that.idToEntryMap[itemId]);
                    if (alreadyExists) {
                        //highlight the existing entry with the same ID and delete this one
                        that.removeEntry($entry);
                        that.addEntry(item, true);
                        e.stopPropagation(); //without this, focus will eventually get called on an empty node we just cleared and error
                    } else {
                        //replace the text and ID of the current le-entry slot
                        // we can't just use remove/addEntry because entry order is often important
                        that._clearEntryId($entry); //to keep the idToItemMap and idToEntryMaps clean
                        that.setEntryId($entry, itemId);
                        that._updateEntry(item, itemId);
                    }
                }
            } else {
                //the user typed in a string we couldn't convert to an item
                that._clearEntryId($entry);
            }
        }

        that.clearActiveEntry();
    });

    if (this.editFriendly) {
        $container.on('click', '.le-edit', function(e) {
            e.preventDefault();
            that.setActiveEntry($(this).attr('_le_index')*1, true);
            return false;
        });
    } else {
        $container.on('click', '.le-displayarea', function(e) {
            e.preventDefault();
            that.setActiveEntry($('.le-display',$(this)).attr('_le_index')*1);
            return false;
        });
        $container.on('click', '.le-edit', function(e) {
            return false;
        });
    }
    if (this.dropdownFn) {
        $container.on('click', '.le-content, .le-actions-trigger', function(e) {
            var id = that._getEntryId($(this).parents('.le-entry:first'));
            var $actionsTrigger = $(this).closest('.le-entry').find('.le-actions-trigger');
            that.dropdownFn($actionsTrigger, id);
            return false;
        });
    }
    if (!this.noRemove) {
        $container.on('click', '.le-remove-trigger', function(e) {
            that.removeEntry($(this).parents('.le-entry:first'), true);
            if (that.autoHideInput) { that._updateShowHideInputSection(); }
            return false;
        });
    }
    if (this.triggerMap) {
        $container.on('click', '.le-trigger', function(e) {
            var name = $(this).attr('name');
            var $entry = $(this).closest('.le-entry');
            var id = that._getEntryId($entry);
            var text = that._getEntryText($entry);
            // In case the triggerFn wants to remove the trigger after the first click
            var removeTriggerFn = function() {
                that._removeEntryTrigger($entry);
            };
            that.triggerMap[name](id, text, removeTriggerFn);
            return false;
        });
    }
    if (this.sortable) {
        this.$listContainer.sortable({
            handle: '.le-sort',
            items: 'li.le-entry',
            cursor: 'move',
            update: function(event, ui) {
                that._recalcIndexes();
                if (that.sortSaveFn) {
                    var ids = [];
                    $('.le-entry', that.$listContainer).each(function() {
                        var id = that._getEntryId($(this));
                        if (id) { ids.push(id); }
                    });
                    that.sortSaveFn(ids);
                }
            },
            forcePlaceholderSize: true, // without this drop zone targets can be too small
            placeholder: 'el8ListItemPlaceholder', // improves drop zone visibility (optional)
            connectWith: this.sortableConnectWith,
            remove: this.sortableRemoveFn,
            activate: this.sortableActivateFn,
            deactivate: this.sortableDeactivateFn,
            tolerance: 'pointer' // greater sensitivity works better for large elements
        });
    }
    return this;
};

el8.uiwidget.listeditor.prototype.setNextElt = function(elt) {
    if (!elt) { return null; }
    var nextElt = elt;
    if (nextElt instanceof Function) {
        this.focusExternalNext = nextElt;
    } else {
        this.focusExternalNext = function() { nextElt.focusFocus(); };
    }
};
el8.uiwidget.listeditor.prototype.setPrevElt = function(elt) {
    if (!elt) { return null; }
    var prevElt = elt;
    if (prevElt instanceof Function) {
        this.focusExternalPrev = prevElt;
    } else {
        this.focusExternalPrev = function() { prevElt.focusFocus(); };
    }
};

// ***********************
// Adding/removing/updating entries
// ***********************
el8.uiwidget.listeditor.prototype.addEntry = function(item, doHighlight, async) {
    var id = this.getItemIdFn ? this.getItemIdFn(item) : null;
    var $entry;
    // If $entry with same ID exists, just update
    if (id && this.idToEntryMap[id]) {
        this._updateEntry(item, id); // TODO add async opts?
        $entry = this.idToEntryMap[id];
    } else {
        $entry = this._createEntry(item);
        this._populateEntry($entry, item, async);
    }
    if (doHighlight) {
        this.highlightEntry($entry);
    }
    if (this.autoHideInput) { this._updateShowHideInputSection(); }
    return this;
};

el8.uiwidget.listeditor.prototype.addEntryAsClean = function(item, doHighlight, async) {
    // Same as the above but marks the widget clean when adding. Used when populating a VN
    // and also when populating multilists each multilist item has a "child" listeditor
    this.addEntry(item, doHighlight, async);
    this._lastSavedEntries = this.getAllEntries();
};

el8.uiwidget.listeditor.prototype.addTextEntry = function(text, doHighlight, async) {
    if (!this.convertTextToItemFn) { this.addEntry.apply(this, arguments); }

    var item = this.convertTextToItemFn(text);
    return this.addEntry(item, doHighlight, async);
};

el8.uiwidget.listeditor.prototype.addEntries = function(items, doHighlight) {
    for (var i=0; i<items.length; i++) {
        this.addEntry(items[i], doHighlight);
    }
};

el8.uiwidget.listeditor.prototype.addEntriesAsClean = function(items, doHighlight) {
    for (var i=0; i<items.length; i++) {
        this.addEntryAsClean(items[i], doHighlight);
    }
};

el8.uiwidget.listeditor.prototype.highlightEntry = function($entry) {
    $entry.addClass('el8BlueHighlight');
    $.el8_setTimeout(function() { $entry.removeClass('el8BlueHighlight'); }, 10000);
};

el8.uiwidget.listeditor.prototype.setSaveFn = function(saveFn) {
    this.saveFn = saveFn;
};

el8.uiwidget.listeditor.prototype.hasSaveFn = function() {
    return Boolean(this.saveFn);
};

el8.uiwidget.listeditor.prototype.setRemoveFn = function(removeFn) {
    this.removeFn = removeFn;
};

el8.uiwidget.listeditor.prototype.hasRemoveFn = function() {
    return Boolean(this.removeFn);
};

el8.uiwidget.listeditor.prototype._getDirties = function() {
    // Check the serialized last saved state of the "entry objects" [{id, item, text}]
    // to the current state
    var saved = this._lastSavedEntries;
    var dirties = [];

    _.each(this.getAllEntries(), function(entryObj, idx) {
        if (!saved[idx] || !_.isEqual(entryObj, saved[idx])) { dirties.push(entryObj); }
    });
    return dirties;
};

el8.uiwidget.listeditor.prototype.saveIfDirty = function() {
    var that = this;
    var dirties = this._getDirties();
    _.each(dirties, function (entryObj) {
        // convert "entry obj" back to $entry and sync save. Unsaved entries (without ids),
        // are saved by the blur handler
        if (entryObj.id) {
            that._saveEntry(that.getEntryById(entryObj.id), false);
        }
    });
};

el8.uiwidget.listeditor.prototype._saveEntry = function($entry, async) {
    var that = this;
    if (this.saveFn) {
        return this.saveFn(
            this._getEntryId($entry),
            this._getEntryText($entry),
            this._getIndex($entry), {
                successCb: function(item) {
                    // Set ID upon successful save
                    if (item) { that.setEntryId($entry, item.getId()); }
                    that._lastSavedEntries = that.getAllEntries();

                    // Removing highlight from visit note template if we edited it
                    // and server marks it as not coming from VNT - but only when
                    // the item actually has the isEditedByVnt field

                    if (that.shouldItemHighlightFn(item)) {
                        $entry.addClass('el8BlueHighlight');
                    } else {
                        $entry.removeClass('el8BlueHighlight');
                    }
                },
                errorCb: function() {
                },
                async: async
            }
        );
    }
};

el8.uiwidget.listeditor.prototype._createEntry = function(item) {
    var index = this.numEntries();
    var $entry = $(el8.template.uiwidget.listeditor.entry({
        sortable: this.sortable,
        index: index,
        spellcheck: el8.util.consts.SPELLCHECK,
        maxLength: this.maxLength,
        addEditIcon: (!this.editFriendly && !this.readOnly),
        addRemoveTrigger: !this.noRemove,
        addActionsMenu: this.dropdownFn,
        readOnly: this.readOnly
    }));
    if (this.sortable && item && _.isFinite(item.getRank()) && item.getRank() < 1) {
        this.$listContainer.prepend($entry);
        this._recalcIndexes();
    } else {
        this.$listContainer.append($entry);
    }

    return $entry;
};

el8.uiwidget.listeditor.prototype._populateEntry = function($entry, item, async) {
    if (!item) { return; }
    var val = null;
    var triggerName = null;
    var highlight = false;

    if (typeof item === 'string') {
        val = item;
        // See if there's a default trigger
        triggerName = this.getItemTriggerFn(null);
    } else {
        val = this.getItemTextFn(item);
        triggerName = this.getItemTriggerFn(item);
        highlight = this.shouldItemHighlightFn(item);
    }
    if (val) {
        if (this.maxLength) {
            //JQuery .val() does not respect the maxlength attribute
            val = val.substr(0, this.maxLength);
        }
        val = el8.util.string.cleanMultiByteChars(val); // remove emoji
        $('.le-edit', $entry).val(val);
        var displayVal = val.el8_escape();
        $('.le-display', $entry).html(displayVal);
    }
    if (triggerName) {
        if (!$('.le-trigger', $entry).length) {
            $('.le-content', $entry).append($('<a class="le-trigger">'));
        }
        $('.le-trigger', $entry).attr('name', triggerName)
            .text(triggerName);
    }
    this._computeDisplaySizes($entry);
    if (!this._getEntryId($entry)) {
        var id;
        // Only populate id if $entry doesn't already have one
        if (typeof item === 'string') {
            id = null; // there's no id if item is a string
        } else {
            id = this.getItemIdFn ? this.getItemIdFn(item) : null;
        }
        if (id) {
            this.setEntryId($entry, id);
            this.idToItemMap[id] = item;
        } else {
            this._saveEntry($entry, async);
        }
    }
    if (val) {
        // need to defer this until the id has been populated
        this._updateLeDisplay($entry);
    }
    this.addEntryFn();

    if (highlight) {
        $entry.addClass('el8BlueHighlight');
    }
};

el8.uiwidget.listeditor.prototype._updateEntry = function(item, id) {
    if (!id) { return null; }
    this.idToItemMap[id] = item;
    var $entry = this.idToEntryMap[id];
    this._populateEntry($entry, item);
};

el8.uiwidget.listeditor.prototype.removeEntry = function($entry, doDelete) {
    $entry.remove();
    var id = this._getEntryId($entry);
    if (id) {
        delete this.idToEntryMap[id];
        delete this.idToItemMap[id];
    }
    this._recalcIndexes();
    if (doDelete === true) {
        this.removeFn(this._getEntryId($entry));
    }
};

el8.uiwidget.listeditor.prototype.getEntryById = function(id) {
    return this.idToEntryMap[id];
};

el8.uiwidget.listeditor.prototype.setEntryId = function($entry, id) {
    if (!id) { return null; }
    $entry.attr('_id', id);
    if (this.idPrefix) { $entry.attr('id', this.idPrefix+'_'+id); }
    this.idToEntryMap[id] = $entry;
    delete this.idToItemMap[id];
};

el8.uiwidget.listeditor.prototype._clearEntryId = function($entry) {
    if (!$entry) { return null; }
    var curId = this._getEntryId($entry);
    if (!curId) { return null; }

    $entry.removeAttr('_id');
    if (this.idPrefix) { $entry.removeAttr('id'); }
    delete this.idToEntryMap[curId];
    delete this.idToItemMap[curId];
};

el8.uiwidget.listeditor.prototype.numEntries = function() {
    return $("li.le-entry", this.$listContainer).length;
};

el8.uiwidget.listeditor.prototype.getNthEntry = function(n) {
    var mod_n = n % this.numEntries();
    return $("li.le-entry", this.$listContainer).eq(mod_n);
};

el8.uiwidget.listeditor.prototype.getNthEntryText = function(n) {
    var $entry = this.getNthEntry(n);
    return $entry.length ? this._getEntryText($entry) : '';
};

el8.uiwidget.listeditor.prototype.getNthEntryId = function(n) {
    var $entry = this.getNthEntry(n);
    return $entry.length ? this._getEntryId($entry) : '';
};

el8.uiwidget.listeditor.prototype.updateNthEntry = function(n, item) {
    var $entry = this.getNthEntry(n);
    var id = this.getItemIdFn ? this.getItemIdFn(item) : null;
    if (!id) { return null; }
    this.idToItemMap[id] = item;
    this._populateEntry($entry, item);
};

el8.uiwidget.listeditor.prototype.addNewEntry = function(item) {
    var $entry = this._createEntry(item);
    this._populateEntry($entry, item);
    if (this.autoHideInput) { this._updateShowHideInputSection(); }
};

// Returns 'false' if an le-entry isn't activated
el8.uiwidget.listeditor.prototype.activateNext = function() {
    var index = this.activeIndex + 1;
    if (this._isEmptyEntry(this.$activeEntry)) { // if empty, stay in place
        return true;
    } else if (index >= this.numEntries()) {
        // When reach bottom, go to input field
        index = this.activeIndex;
        this._setDisplayMode(index);
        this._activateInput();
        return false;
    } else {
        this.setActiveEntry(index);
        return true;
    }
};

el8.uiwidget.listeditor.prototype.activatePrev = function() {
    var index = this.activeIndex - 1;
    if (index < 0) {
        index = this.activeIndex; // Don't move above top
        if (this.focusExternalPrev) {
            this.clearActiveEntry();
            this.focusExternalPrev();
        }
        return false;
    } else {
        this.setActiveEntry(index);
        return true;
    }
};

el8.uiwidget.listeditor.prototype.setActiveEntry = function(arg, noFocus) {
    // "arg" can be either number or jQuery obj
    var index = (arg instanceof Object) ? this._getIndex(arg) : arg;
    this.clearActiveEntry();
    this.$activeEntry = null;
    this.activeIndex = -1;

    if ((index !== null) && (index >= 0)) {
        this.$activeEntry = this._setEditMode(index, noFocus);
        this.activeIndex = index;
    }
};

el8.uiwidget.listeditor.prototype.clearActiveEntry = function() {
    //if we have display-only text, we need to set le-display even if there's no active entry
    if (this.activeIndex >= 0 || this.getItemDisplayOnlyTextFn) {
        //getNthEntry(-1) will return the le-input
        this._setDisplayMode(this.activeIndex);
    }
    if (this.mindreader) { this.mindreader.hide(); }
    return this;
};

el8.uiwidget.listeditor.prototype._activateInput = function() {
    this._showInputSection();
    this.clearActiveEntry();
    this.$input.scrollintoview().focusFocus();
};

el8.uiwidget.listeditor.prototype._setDisplayMode = function(arg) {
    // "arg" can be either number or jQuery obj
    var $entry = (arg instanceof Object) ? arg : this.getNthEntry(arg);

    if ($entry.hasClass("active")) {
        $entry.removeClass("active");
        if (this.mindreader) {
            this.mindreader.hide();
            this.mindreader.init(this.$input);
        }
        if (this._isEmptyEntry($entry)) {
            this.removeEntry($entry, true);
        } else {
            this._updateLeDisplay($entry);
            this._saveEntry($entry);
        }
    } else if ($entry && $entry.length) {
        //ignore the case when a dialog is first opened and the input is empty
        this._updateLeDisplay($entry);
    }
    return $entry;
};

el8.uiwidget.listeditor.prototype._setEditMode = function(arg, noFocus) {
    // "arg" can be either number or jQuery obj
    var $entry = (arg instanceof Object) ? arg : this.getNthEntry(arg);
    if (!$entry.hasClass("active")) {
        $entry.addClass("active");
        this._computeEditSizes($entry);
        var $edit = $('.le-edit', $entry);
        //var entryId = this._getEntryId($entry);
        if (!this.getItemDisplayOnlyTextFn) { //TODO: this block is probably not actaully necessary. Investigate
            var $display = $('.le-display', $entry);
            var displayVal = $display.text();
            $edit.val(displayVal);
        }
        if (!this.editFriendly) {
            if ($edit.val().length) { el8.util.dom.moveCursor($edit, $edit.val().length); }
        }
        if (this.mindreader) { this.mindreader.init($edit); }
        if (!noFocus) {
            $edit.scrollintoview()
                .focus()
                .get(0).focus();
        }
        $('.le-actions-container', $entry).hide();
    }
    return $entry;
};

el8.uiwidget.listeditor.prototype._getIndex = function($elt) {
    return $(".le-entry", this.$listContainer).index($elt);
};

el8.uiwidget.listeditor.prototype._showInputSection = function() {
    if (this.$inputArea.is(':hidden')) {
        this.$inputArea.show();
    }
};

el8.uiwidget.listeditor.prototype._updateShowHideInputSection = function() {
    if (this.numEntries() > 0) {
        if (!this.$inputArea.is(':hidden')) {
            this.$inputArea.hide();
        }
    } else {
        this._showInputSection();
    }
    this._updateTabIndex();
};

/**
 * Show/hide the whole LE (list and input)
 */
el8.uiwidget.listeditor.prototype.hideLe = function() {
    this.$listContainer.parent('.le-container').hide();
};
el8.uiwidget.listeditor.prototype.showLe = function() {
    this.$listContainer.parent('.le-container').show();
};


// *********************
// Content retrieval API
// *********************
el8.uiwidget.listeditor.prototype.getAllEntries = function() {
    var result = [];
    var that = this;
    $('.le-entry', this.$listContainer).each(function() {
        var id = that._getEntryId($(this));
        var text = that._getEntryText($(this));
        var item = that.idToItemMap[id] || null;
        result.push({id: id, text: text, item: item});
    });
    return result;
};
el8.uiwidget.listeditor.prototype.editEntry = function($entry, noFocus) {
    if (this.onEditStart) {
      this.onEditStart($entry);
    }
    this.setActiveEntry($('.le-display', $entry).attr('_le_index')*1, noFocus);
};
el8.uiwidget.listeditor.prototype.isEmpty = function() {
    return this.numEntries() === 0;
};
el8.uiwidget.listeditor.prototype.reset = function() {
    var that = this;
    $("li.le-entry", this.$listContainer).each(function() {
        that.removeEntry($(this));
    });
    this.activeIndex = -1;
    this.$activeEntry = null;
    this.idToEntryMap = {};
    this.idToItemMap = {};
    if (this.mindreader && this.mindreader.isShown) {
        this.mindreader.hide();
    }
    if (this.autoHideInput) { this._updateShowHideInputSection(); }
};
el8.uiwidget.listeditor.prototype.saveAll = function() {
    var that = this;
    $('.le-entry', this.$listContainer).each(function() {
        that._saveEntry($(this));
    });
};

// *********************
// Helper functions
// *********************
el8.uiwidget.listeditor.prototype._safeGetHeight = function($element) {
    if ($element.length === 0) return undefined;

    return $element[0].offsetHeight;
}
el8.uiwidget.listeditor.prototype._isEmptyEntry = function($entry) {
    return ($('.le-edit', $entry).val() === '');
};
el8.uiwidget.listeditor.prototype._getEntryId = function($entry) {
    return $entry.attr('_id') || null;
};
el8.uiwidget.listeditor.prototype._getEntryText = function($entry) {
    var val;
    if (this.getItemDisplayOnlyTextFn) {
        val = $entry.find('.le-edit').val(); //don't include display-only text
    } else {
        val = $entry.find('.le-display').text();
    }
    return val;
};
el8.uiwidget.listeditor.prototype._removeEntryTrigger = function($entry) {
    $entry.find('.le-trigger').remove();
};
el8.uiwidget.listeditor.prototype._updateTabIndex = function() {
    $('.le-edit', this.$listContainer).attr('tabindex', '-1');
    $('.le-edit:last', this.$listContainer).removeAttr('tabindex');
};
el8.uiwidget.listeditor.prototype._recalcIndexes = function() {
    $('.le-entry', this.$listContainer).each(function(index) {
        $('.le-display', $(this)).attr('_le_index', index);
        $('.le-edit', $(this)).attr('_le_index', index);
    });
};
el8.uiwidget.listeditor.prototype._computeDisplaySizes = function($entry) {

    // Adjust all the widths before getting reference height, width of disparea
    var $content = $('.le-content', $entry);
    $content.css('margin-left', this.iconWidth);

    var $icon = $('.le-icon', $entry);
    $icon.outerWidth(this.iconWidth);

    var dispareaHeight = (this.editFriendly || this.readOnly) ?
                            this._safeGetHeight($('.le-display', $entry)) :
                            this._safeGetHeight($('.le-displayarea', $entry));

    $entry.height(Math.max(this.entryHeight, dispareaHeight));
    $icon.height(Math.max(this.entryHeight, dispareaHeight));

    if (this.editFriendly) {
        var $edit = $('.le-edit', $entry);
        $edit.height(Math.max(this.entryHeight, dispareaHeight))
            .css('width', '100%');

    } else {
        var $edit = $('.le-edit', $entry).hide();
        if ($edit.height() < dispareaHeight) { $edit.height(dispareaHeight); }
    }
};
el8.uiwidget.listeditor.prototype._updateLeDisplay = function($entry) {
    var val;
    var entryId = this._getEntryId($entry);

    if (this.getItemDisplayOnlyTextFn) {
        if (entryId) {
            val = this.getItemDisplayOnlyTextFn(this.idToItemMap[entryId] || entryId);
        } else {
            //will usually just be the entry text, but sometimes there may be an "invalid" indicator
            val = $('.le-edit', $entry).val() + this.getItemDisplayOnlyTextFn(null);
        }
    } else {
        val = $('.le-edit', $entry).val();
    }
    var displayVal = val.el8_escape();
    $('.le-display', $entry).html(displayVal);
    this._computeDisplaySizes($entry);
    $('.le-actions-container', $entry).show();
};
el8.uiwidget.listeditor.prototype._computeEditSizes = function($entry) {

    var dispHeight = this.editFriendly ? this._safeGetHeight($('.le-display', $entry)) :
                            this._safeGetHeight($('.le-displayarea', $entry));
    $entry.height(Math.max(this.entryHeight, dispHeight));

    var $edit = $('.le-edit', $entry);
    $edit.height(Math.max(this.entryHeight, dispHeight));
    if (!this.editFriendly) { $edit.show(); }

    var contentWidth = $('.le-content', $entry).width();
    $edit.outerWidth(contentWidth);
};
el8.uiwidget.listeditor.prototype._growTextarea = function($ta, $wrapper) {
    el8.util.dom.adjustTextareaHeight($ta, $wrapper);
};
el8.uiwidget.listeditor.prototype._selectInput = function() {
    var that = this;
    var addStringEntry = function(textVal) {
        if (that._handleStringEntryFn) {
            // exclusive with adding textVal to the LE
            that._handleStringEntryFn(textVal);
        } else {
            var $entry = that._createEntry(item);
            that._populateEntry($entry, textVal);
        }
    };

    var textVal = this.infoField.getVal();
    if (textVal) {
        // Add entry to UI
        if (this.convertTextToItemFn) {
            var item = this.convertTextToItemFn(textVal);
            if (item && typeof item !== 'string') {
                // for items with ID, use addEntry so same-ID items resolve together
                var alreadyExists = Boolean(this.idToEntryMap[this.getItemIdFn(item)]);
                this.addEntry(item, alreadyExists); //highlight item if already-exists
            } else {
                // but if they don't have an ID, avoid "item has no property getId" errors
                addStringEntry(textVal);
            }
        } else {
            addStringEntry(textVal);
        }
        // Reset input field
        this.infoField.setVal('');
        if (this.mindreader) { this.mindreader.hide(); }
        this.$input.height(this.entryHeight);
    }
};
el8.uiwidget.listeditor.prototype._selectActiveInputOrEntry = function() {
    if (this.infoField.getVal()) { //assumes input field always clears on blur
        this._selectInput();
    } else {
        this.clearActiveEntry();
    }
};
el8.uiwidget.listeditor.prototype._getActiveInputOrEntry = function() {
    if (this.infoField.getVal()) {
        return this.$input;
    } else {
        if (this.activeIndex >= 0) {
            return this.getNthEntry(this.activeIndex);
        }
    }
    return null;
};
el8.uiwidget.listeditor.prototype._bindMouseHandlers = function() {
    if (!this._isMouseBinded) {
        var that = this;
        /* This is pretty hack-y. _bindMouseHandlers is called by a 'focus' handler. So if
         * the focus is caused by a click, clickHandler will run during the initial click into
         * the empty input, which we do not want, because if a mindreader is supposed to open,
         * it will be immediately closed. So this delays doing the actual bind for long enough
         * for the first 'click' event to just get ignored... */
        _.delay(function() {
            if (that._isMouseBinded) { return; }
            $(document).on('click', that._clickHandler);
            $(document).on('mousedown', '.mr-dropdown',  that._mrMousedownHandler);
            that._isMouseBinded = true;
        }, 200);
    }
};
el8.uiwidget.listeditor.prototype._unbindMouseHandlers = function() {
    if (this._isMouseBinded) {
        $(document).unbind('click', this._clickHandler);
        $(document).off('mousedown', '.mr-dropdown', this._mrMousedownHandler);
        this._isMouseBinded = false;
    }
};
el8.uiwidget.listeditor.prototype._selectFromMindreader = function(e, $input) {
    if (this.mindreader) {
        var value = '';
        var $entry = null;
        if ($input) {
            value = $input.val();
        } else {
            $entry = this._getActiveInputOrEntry();
            if ($entry) {
                $input = $entry.find('.le-edit');
                value = $input.val();
            }
        }
        this.mindreader.selectActiveResult(e);
        // Sticky list input lets you edit the line some more even
        // after mindreader selects
        if (!this._opts.mindreaderOpts['stickyListInput'] ||
                ($input ? $input.val() : '') === value) {

            // we can't use "value" here because after a click, it will actually be based on the value of
            // the first le-entry (via _getActiveInputOrEntry) rather than the le-input at the bottom
            var justTyped = this.infoField.getVal();
            if (!this._opts.mindreaderOpts['noRepeatEmptyQuery'] || justTyped !== '') {
                // don't select the input if we have an empty field and we're consciously trying
                // not to show the emptyQueryData multiple times
                this._unbindMouseHandlers();
                this._selectActiveInputOrEntry();
                // we don't want to activateInput if we're trying to avoid repeating the empty query,
                // because focusing on the (now empty) input will bring up emptyQueryData again
                if (!this._opts.mindreaderOpts['noRepeatEmptyQuery']) { this._activateInput(); }
            }
        } else {
            // If we have sticky list input, then adjust edit entry sizes
            // and hide mindreader
            this._growTextarea($input, $entry);
            this.mindreader.hide();
        }
    }
};

el8.uiwidget.listeditor.prototype.setInputVal = function(val) {
    this.infoField.setVal(val);
};

el8.uiwidget.listeditor.prototype.getInfoField = function() {
    return this.infoField;
};

el8.uiwidget.listeditor.prototype.getMindreader = function() {
    return this.mindreader;
};

el8.uiwidget.listeditor.prototype.resizeAdjust = function() {
    var that = this;
    $('.le-entry',this.$listContainer).each(function(index, elt) {
        that._computeDisplaySizes($(elt));
    });
};

el8.uiwidget.listeditor.prototype.displayReadOnlyEmpty = function() {
    var $emptyEntry = $(el8.template.uiwidget.listeditor.emptyEntry());
    this.$listContainer.html($emptyEntry);
};

el8.uiwidget.listeditor.prototype.getJsonData = function() {
    var entries = this.getAllEntries();
    if (entries && entries.length) {
        return _.map(entries, function(entry) {
            return {
                text: entry.text
            };
        });
    } else {
        return null;
    }
};
